import axios from "axios";
import { trim } from "lodash";
import React, { useEffect, useReducer, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FiUpload } from "react-icons/fi";
import { Link, useNavigate, useParams } from "react-router-dom";
import validator from "validator";
import Loader from "../../Components/Global/Loader";
import DashboardLayouts from "../../Components/Layout/DashboardLayouts";

import DummyImg from "../../Public/Images/568165.png";

import useAuthentication from "../../hooks/useAuthentication";
import useAxiosFetch from "../../hooks/useAxiosFetch";

function TaskView({ allowedRoles }) {
  const { allowLoading } = useAuthentication(allowedRoles);

 const  initialState ={
  showImage:"",
  errorMessage:{},
  setTaskImages:[],
start_date:"",
end_date:"",
worker_status:"",
task_description:"",
description:"",
supplier_details: [
      {
        supplier_name: "",
        phone_number: "",
        amount: "",
        worklog: "",
        remarks: "",
      },
    ],
 }

 const taskUpdateFunc=(state,action) => {
 
switch(action.type){
  case "input":
    return {...state, [action.payload.target.name]: action.payload.target.value} ;
    case "date":
      return {...state, [action.payload.name]: action.payload.value} ;

      case "add_row_supplier_details":
        return {
          ...state,
          supplier_details: [...state.supplier_details,  {
            supplier_name: "",
            phone_number: "",
            amount: "",
            worklog: "",
            remarks: "",
          },]
        };
      case "update_field_supplier_details":
        const newRows = [...state.supplier_details];
        newRows[action.index][action.field] = action.value;
        return {
          ...state,
          supplier_details: newRows
        };


        case "remove_row_supplier_details":
          return {
            ...state,
            supplier_details: state.supplier_details.filter((_, i) => i !== action.index)
          };
        case "show_default_img":
          return {
            ...state,
            showImage: action.payload
          };
        case "show_error":
          return {
            ...state,
            errorMessage: action.payload
          };
        case "remove_error":
          return {
            ...state,
            errorMessage: {}
          };
   
    case "update_from_api":
      return {...state, ...action.payload ,end_date: new Date(action?.payload?.deadline),start_date: new Date(action?.payload?.createdAt),setTaskImages:JSON.parse(action?.payload?.task_image) ,showImage:JSON.parse(action?.payload?.task_image)[0]} ;
default:
  return state;
}
 }


const[taskDataState,dispatch] =useReducer(taskUpdateFunc,initialState)


  const { id } = useParams();
  const [loading, setLoading] = useState(false);


    // api api from global hook 

  const { axiosFetch} = useAxiosFetch();

 
const {errorMessage}=taskDataState;
 
  const route = useNavigate();

  useEffect(() => {
    WorkUpdateFunc();
 
  }, [id]);

  const WorkUpdateFunc = () => {
    setLoading(true);
    axios
      .get(`/task/show/${id}`)
      .then((res) => {
           
            // setTaskImages(JSON.parse(res.data?.TaskList?.task_image));
          dispatch({type:"update_from_api",payload:res.data?.TaskList})
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
          });
  };
  const onClickImages = (url) => {
    // setShowimage(url);
    dispatch({type:"show_default_img",payload:url})

  };



  const validation = () => {
    const errors = {};

    dispatch({type:"remove_error"})

    taskDataState.supplier_details.find((ph) => {
      if (trim(ph.phone_number) && !validator.isMobilePhone(ph.phone_number)) {
        return (errors.phone_number = "Please enter a valid phone number");
      }
      if (trim(ph.amount) && !validator.isInt(ph.amount)) {
        return (errors.amount = "Please enter a valid  number");
      }
    });

    if (!taskDataState?.start_date || !trim(taskDataState?.start_date)) {
      errors.start_date = "Please enter your lease start date.";
    }
    if (!taskDataState?.end_date || !trim(taskDataState?.end_date)) {
      errors.end_date = `Please enter your lease ${
        taskDataState?.worker_status !== "Completed" ? "Probable" : ""
      } end date.`;
    }

    if (taskDataState?.start_date && taskDataState?.end_date) {
      if (new Date(taskDataState?.start_date) > new Date(taskDataState?.end_date)) {
        errors.end_date = `${
          taskDataState?.worker_status !== "Completed" ? "Probable" : ""
        } End date can't be before start date`;
      }
    }

   

    return errors;
  };

  const SubmitHandler = (e) => {
  
    e.preventDefault();
    
    const Valid = validation();

dispatch({type:"show_error", payload: Valid})
    if ( Object.keys(Valid)?.length == 0) {
  
     

    
      setLoading(true);
      axios
        .post(`/worker/task/update/${id}`, {...taskDataState,probable_end_data:taskDataState.end_date})
        .then(function (response) {
          setLoading(false);
          if (response.status === 200) {
            setLoading(false);
            route("/workerdashboard");
          } else if (response.status === 401) {
            setLoading(false);
          }
        })
        .catch(function (error) {
          setLoading(false);
        });
    }
  };




  const handleAddRow = () => {
    dispatch({ type: "add_row_supplier_details" });
  };

  const handleInputChange = (index, field, value) => {
    dispatch({ type: "update_field_supplier_details", index, field, value });
  };

  const handleRemoveRow = index => {
    dispatch({ type: "remove_row_supplier_details", index });
  };


  return (
    <DashboardLayouts>
      {(loading || allowLoading) && <Loader />}
      <div className="worker-dashboard-wrapper">
        <div className="building-details w-100">
          <div className="row justify-content-between align-items-center">
            <div className="col-xl-6 d-flex align-items-center col-md-4 col-6">
              <h3 className="heading-text fw-bold mb-0"> Task Title</h3>
            </div>

            <div className="col-lg-auto d-flex justify-content-end align-items-center btn-responsive col-6">
              <Link
                type="button"
                to="/workerdashboard"
                className="btn btn-outline-primary"
              >
                Back To Task List
              </Link>
            </div>
          </div>
        </div>

        <div className="task-area">
          <div className="row">
            <div className="col-xl-7 col-md-auto col-lg-7 col-md-7">
              <h4> {taskDataState?.task_title}</h4>
              <ul className="d-flex flex-wrap">
                <li className="list-info">
                  <span>Unit Name :</span>
                  <p>{taskDataState?.unitId?.unit_name}</p>
                </li>

                <li className="list-info">
                  <span>Buildings :</span>
                  <p>{taskDataState?.buildingId?.building_name}</p>
                </li>

                <li className="list-info">
                  <span>Priority :</span>
                  <p>{taskDataState?.priority}</p>
                </li>

                <li className="list-info">
                  <span>Assign By :</span>
                  <p>
                    {`${
                      taskDataState?.createdBy?.first_name == null
                        ? ""
                        : taskDataState?.createdBy?.first_name
                    } ${
                      taskDataState?.createdBy?.middle_name == null
                        ? ""
                        : taskDataState?.createdBy?.middle_name
                    }
                    ${
                      taskDataState?.createdBy?.last_name == null
                        ? ""
                        : taskDataState?.createdBy?.last_name
                    }
                    `}
                  </p>
                </li>
              </ul>
              <ul>
             
                <li className="list-info">
                  <span>Description :</span>
                  <p>{taskDataState?.task_description}</p>
                </li>
              </ul>
            </div>

            <div className="col-lg-5 mt-md-4 mt-lg-0">
              <div className="d-flex align-items-center justify-content-center justify-content-lg-end">
                <div className="area-hide add-building-img">
                  <div className="image-area d-flex align-items-center justify-content-center position-relative">
                  
                          <div >
                            <img
                              id="show-image"
                              src={taskDataState?.showImage ? taskDataState?.showImage :DummyImg}
                              alt=""
                            />
                          </div>
                       
                  </div>
                  {taskDataState?.setTaskImages?.length > 0 && (
                    <div className="add-images d-flex ">
                      {taskDataState?.setTaskImages?.map((url, index) => {
                        return (
                          <div className="img-sec" key={index}>
                            <img
                              id="show-image"
                              src={url}
                              alt=""
                              onClick={() => onClickImages(url)}
                            />
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="add-request-form w-100">
          <div className="d-flex justify-content-between align-items-center mt-xl-5 mt-3 mb-xl-4 mb-3">
            <h3 className="heading-text fw-bold">Work Update</h3>
            <div className="upload-area">
              <label htmlFor="image" className="file-upload-area d-flex">
                Upload Documents
                <FiUpload className="ms-2 ms-lg-3 upload-icon" />
              </label>
            </div>
          </div>
          <div className="row gy-2 gy-lg-4 gx-xl-5">
            <div className="col-xl-7">
              <form action="" className="dash-form add-form">
                <div className="row">
                  <div className="col-lg-4 mb-2 mt-4">
                    <label htmlFor="" className="form-lbl">
                      Status
                    </label>
                    <div className="form-group">
                      <select
                        name="worker_status"
                        id="worker_status"
                        value={taskDataState?.worker_status}
                        onChange={(e) => dispatch({type:"input",payload:e})}
                        // onChange={(e) => WorkerUpdateFunc(e)}
                        className="form-control form-g1"
                      >
                        <option value="">Choose Status</option>
                        <option value="Completed">Completed</option>
                        <option value="Pending">Pending</option>
                        <option value="In Progress">In Progress</option>
                      </select>
                    </div>
                    {errorMessage?.status_message ? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.status_message}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="col-lg-4 col-md-6 mb-2 mt-4">
                    <div className="form-group">
                      <label htmlFor="start_date" className="form-lbl">
                        Start Date <span className="must-field">*</span>
                      </label>

                      <DatePicker
                        selected={taskDataState?.start_date}
                       
                        onChange={(date) => {
                          dispatch({ type:"date", payload:{name:"start_date",value:date}})
                        }}
                        required
                        className="form-control form-g1"
                      />

                      {errorMessage?.start_date ? (
                        <div
                          className="error error-message"
                          style={{ color: "red" }}
                        >
                          {errorMessage?.start_date}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 mb-2 mt-4">
                    <div className="form-group">
                      <label htmlFor="end_date" className="form-lbl">
                        {taskDataState?.worker_status !== "Completed" && "Probable"} End Date{" "}
                        <span className="must-field">*</span>
                      </label>

                      <DatePicker
                      
                        selected={taskDataState?.end_date}
                       
                        onChange={(date) => {
                          dispatch({ type:"date", payload:{name:"end_date",value:date}})
                        }}
                        required
                       

                        className="form-control form-g1"
                      />

                      {errorMessage?.end_date ? (
                        <div
                          className="error error-message"
                          style={{ color: "red" }}
                        >
                          {errorMessage?.end_date}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="col-xl-12 mb-4 mt-4">
                    <label htmlFor="" className="form-lbl">
                      Description
                    </label>
                    <div className="form-group">
                      <textarea
                        className="form-control form-g1"
                        id="description"
                        name="task_description"
                        value={taskDataState?.task_description}
                        onChange={(e) => dispatch({type:"input",payload:e})}
                        placeholder="Description"
                      ></textarea>
                    </div>
                  </div>
                </div>

                <h3 className="heading-text fw-bold ">Supplier Part </h3>
                {taskDataState?.supplier_details?.map((setvalue, index) => (
                  <div key={index} className="supplier-details row">
                    <div className="col-md-4 mb-2 mt-4">
                      <div className="form-group">
                        <label htmlFor="" className="form-lbl">
                          Supplier Name
                        </label>
                        <input
                          type="text"
                          className="form-control form-g1"
                          id="form-request*"
                          name="supplier_name"
                          value={setvalue.supplier_name}
                  
                          onChange={e => handleInputChange(index, "supplier_name", e.target.value)}
                       
                          placeholder=""
                        />
                      </div>
                    </div>
                    <div className="col-6 col-md-4 mb-2 mt-4">
                      <div className="form-group">
                        <label htmlFor="" className="form-lbl">
                          Phone Number
                        </label>
                        <input
                          type="text"
                          className="form-control form-g1"
                          id="form-request*"
                          name="phone_number"
                          value={setvalue.phone_number}
                          onChange={e => handleInputChange(index, "phone_number", e.target.value)}
                          placeholder=""
                        />
                        {trim(setvalue.phone_number) &&
                          !validator.isMobilePhone(setvalue.phone_number) && (
                            <div
                              className="error error-message"
                              style={{ color: "red" }}
                            >
                              please enter a valid mobile number
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="col-6 col-md-4 mb-2 mt-4">
                      <div className="form-group">
                        <label htmlFor="" className="form-lbl">
                          Work Log
                        </label>
                        <input
                          type="text"
                          className="form-control form-g1"
                          id="form-request*"
                          name="worklog"
                          value={setvalue.worklog}
                          onChange={e => handleInputChange(index, "worklog", e.target.value)}

                          placeholder=""
                        />
                      </div>
                    </div>
                    <div className="col-6 col-md-4 mb-2 mt-4">
                      <div className="form-group">
                        <label htmlFor="" className="form-lbl">
                          Amount
                        </label>
                        <input
                          type="text"
                          className="form-control form-g1"
                          id="form-request*"
                          name="amount"
                          value={setvalue.amount}
                          onChange={e => handleInputChange(index, "amount", e.target.value)}

                          placeholder=""
                        />

                        {trim(setvalue.amount) &&
                          !validator.isInt(setvalue.amount) && (
                            <div
                              className="error error-message"
                              style={{ color: "red" }}
                            >
                              please enter a valid number
                            </div>
                          )}
                      </div>
                    </div>

                    <div className="col-6 col-md-4 mb-2 mt-4">
                      <div className="form-group">
                        <label htmlFor="" className="form-lbl">
                          Remarks
                        </label>
                        <input
                          type="text"
                          className="form-control form-g1"
                          id="form-request*"
                          name="remarks"
                          value={setvalue.remarks}
                          onChange={e => handleInputChange(index, "remarks", e.target.value)}

                          placeholder=""
                        />
                      </div>
                    </div>

                    {taskDataState.supplier_details.length !== 1 && (
                      <div className="col-3 col-md-2 mb-2 d-flex align-items-center">
                        <button
                          className="form-add-btn text-nowrap mt-5 text-start"
                          onClick={() => handleRemoveRow(index)}
                        >
                          - Remove
                        </button>
                      </div>
                    )}
                    {taskDataState.supplier_details.length - 1 === index &&
                      taskDataState.supplier_details.length < 100 && (
                        <>
                          <div className="col-3 col-md-2 mb-2 d-flex align-items-center">
                            <button
                              className="form-add-btn text-nowrap text-start mt-5"
                              onClick={handleAddRow}
                            >
                              Add more +
                            </button>
                          </div>
                        </>
                      )}
                    {/* {workerUpdate.supplier_details.length - 2 === index ? (
                        <hr className="mb-3" />
                      ) : (
                        ""
                      )} */}
                  </div>
                ))}

                <button
                  type="submit"
                  className="btn-primary form-btn mb-4 mt-4"
                  onClick={(e) => {
                    SubmitHandler(e);
                  }}
                >
                  Submit
                </button>
              </form>
            </div>
            <div className="col-xl-5">
              <div className="w-100 overflow-auto table-content">
                <table className="dashboard-table w-100">
                  <thead className="table-heading">
                    <tr>
                      <th className="text-center">Sl no.</th>
                      <th className="text-center">Work Log</th>
                      <th className="text-center">Phone</th>
                      <th className="text-center">Amount</th>
                      <th className="text-center">Remarks</th>
                    </tr>
                  </thead>

                  <tbody className="t-data">
                    {taskDataState?.supplier_details?.length >= 1 ? (
                      taskDataState?.supplier_details?.map((items, i) => {
                        return (
                          <tr key={i}>
                            <td className="text-center">{i + 1}</td>
                            <td className="text-center"> {items?.worklog} </td>
                            <td className="text-center">
                              {" "}
                              {items?.phone_number
                                ? items?.phone_number
                                : "-"}{" "}
                            </td>
                            <td className="text-center"> {items?.amount} </td>
                            <td className="text-center"> {items?.remarks} </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="10" className="text-center">
                          No Task List
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayouts>
  );
}
export default TaskView;
